/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { FetchStoreQuotes } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { FetchStoreQuotesResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * StoreQuotesListApi - axios parameter creator
 * @export
 */
export const StoreQuotesListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch store quotes
         * @summary Fetch store quotes
         * @param {string} storeId The store identifier.
         * @param {FetchStoreQuotes} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQuotes: async (storeId: string, body?: FetchStoreQuotes, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('storeQuotes', 'storeId', storeId)
            const localVarPath = `/store/{storeId}/resources/quote/trackSearch`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreQuotesListApi - functional programming interface
 * @export
 */
export const StoreQuotesListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreQuotesListApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch store quotes
         * @summary Fetch store quotes
         * @param {string} storeId The store identifier.
         * @param {FetchStoreQuotes} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeQuotes(storeId: string, body?: FetchStoreQuotes, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FetchStoreQuotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeQuotes(storeId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreQuotesListApi - factory interface
 * @export
 */
export const StoreQuotesListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreQuotesListApiFp(configuration)
    return {
        /**
         * Fetch store quotes
         * @summary Fetch store quotes
         * @param {string} storeId The store identifier.
         * @param {FetchStoreQuotes} [body] The body data required for the REST method.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeQuotes(storeId: string, body?: FetchStoreQuotes, options?: any): AxiosPromise<FetchStoreQuotesResponse> {
            return localVarFp.storeQuotes(storeId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreQuotesListApi - object-oriented interface
 * @export
 * @class StoreQuotesListApi
 * @extends {BaseAPI}
 */
export class StoreQuotesListApi extends BaseAPI {
    /**
     * Fetch store quotes
     * @summary Fetch store quotes
     * @param {string} storeId The store identifier.
     * @param {FetchStoreQuotes} [body] The body data required for the REST method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreQuotesListApi
     */
    public storeQuotes(storeId: string, body?: FetchStoreQuotes, options?: any) {
        return StoreQuotesListApiFp(this.configuration).storeQuotes(storeId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
